import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CastingFlow } from "../components/CastingFlow";

/**
 * /apply — full-page casting application for touch/mobile devices.
 * Uses native document scrolling (no fixed nested scroll container),
 * so it works reliably inside Instagram/Facebook in-app browsers on iOS.
 */
export default function Apply() {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("dark");
    window.scrollTo(0, 0);
    // Diagnostics only — the architecture does not depend on UA detection
    const ua = navigator.userAgent || "";
    const isInstagram = /Instagram/i.test(ua);
    const isFacebook = /FBAN|FBAV/i.test(ua);
    if (isInstagram || isFacebook) {
      console.debug("[canarts] in-app browser detected", { isInstagram, isFacebook });
    }
  }, []);

  return (
    <div
      data-testid="apply-page"
      className="min-h-screen supports-[height:100dvh]:min-h-[100dvh] bg-[#0a0a0a] text-foreground flex flex-col"
    >
      <CastingFlow variant="page" onClose={() => navigate("/")} />
    </div>
  );
}
